var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatamWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ED1651;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27278",
    className: "st0",
    d: "M28.3,41.3l10.6-3c0,0-0.1-0.7-0.5-1.1c-0.4-0.3-1.1-0.6-1.1-0.6l-14.8-5.4c0,0-0.5-0.2-0.8,0 s-0.3,0.7-0.3,0.7v6.9c0,0,0,0.7,0.9,2.1c1,1.5,3.2,1.1,3.2,1.1L28.3,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27260",
    className: "st0",
    d: "M70.6,24.8l9.9-5.5c0,0,0.1-1-0.2-1.3c-0.4-0.3-0.8-0.5-0.8-0.5L36.7,2.2c0,0-0.5-0.2-0.8,0 C35.6,2.5,35.6,3,35.6,3v5.9c0,0,0,1.4,0.9,2.8c1,1.5,2.5,1.9,2.5,1.9L70.6,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27258",
    className: "st0",
    d: "M70.6,42l9.9-5.1c0,0,0.2-1.3-0.2-1.6c-0.4-0.3-0.9-0.5-0.9-0.5L22.6,14.1c0,0-0.5-0.2-0.8,0 s-0.3,0.7-0.3,0.7v5.9c0,0,0,1.4,0.9,2.8c1,1.5,2.5,1.9,2.5,1.9L70.6,42z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_00000124847860805515526520000005354262819150752666_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27194",
    className: "st1",
    d: "M79.4,17.5c0,0,0.6,0.1,1.1,0.6s0.5,1.1,0.5,1.1V27c0,0,0,1.1-0.5,2c-0.4,1-1.1,1.2-1.1,1.2 l-1.3,0.5L35.4,46.1c0,0-0.2,0.1-0.5,0.1s-0.5-0.1-0.5-0.1l-11.9-4.3c0,0-0.3-0.1-0.7-0.7c-0.5-0.7-0.4-2.2-0.4-2.2 s0.1,0.7,0.5,1.1c0.4,0.4,1.5,0,1.5,0l54.5-19.8c0,0,2.2-0.9,2.2-1.8C80.2,17.7,79.4,17.5,79.4,17.5L79.4,17.5z M79.4,34.7 c0,0,0.6,0.1,1.1,0.6s0.5,1.1,0.5,1.1v7.8c0,0,0,1.1-0.5,2c-0.4,1-1.1,1.2-1.1,1.2l-1.3,0.5L35.4,63.4V52.9L78,37.4 c0,0,2.2-0.9,2.2-1.8C80.2,35,79.4,34.7,79.4,34.7L79.4,34.7z M58.2,62.3c0.4,0.4,0.4,1.3,0.4,1.3v5.9c0,0,0,1.1-0.5,2 S57,72.7,57,72.7l-1.3,0.5l-20.3,7.4V70l20.3-7.4C55.8,62.7,57.8,61.9,58.2,62.3L58.2,62.3z M45.1,84.2c0.4,0.4,0.4,1.3,0.4,1.3 v5.9c0,0,0,1.1-0.5,2s-1,1.2-1,1.2l-1.3,0.5l-7.2,2.7V87.3l7.2-2.7C42.7,84.6,44.7,83.8,45.1,84.2L45.1,84.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatamWhite);
export default __webpack_public_path__ + "static/media/latam-white.d9c4bc347045ebb792af8ff8e36ea725.svg";
export { ForwardRef as ReactComponent };